"use client";
import getLinkWithLang from "@/utils/lang/getLinkWithLang";
import { lang as langType } from "@/utils/lang/langType";
import NextLink, { LinkProps } from "next/link";
import { AnchorHTMLAttributes, FC, ReactNode } from "react";
import { useParams } from "next/navigation";

interface MyLinkProps
  extends LinkProps,
    AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode;
  href: string;
  lang?: langType;
}

const MyLink: FC<MyLinkProps> = ({ href, children, lang, ...props }) => {
  const params = useParams();
  const currentLang = (params?.lang as langType) || lang || "en";
  return (
    <NextLink
      href={getLinkWithLang(href, currentLang)}
      prefetch={false}
      {...props}
    >
      {children}
    </NextLink>
  );
};

export default MyLink;
